export const GET_PRODUCTS_LOADING = "products/loading";
export const GET_PRODUCTS_SUCCESS = "products/success";
export const GET_PRODUCTS_ERROR = "products/error";




export const GET_SINGLE = "products/single"
export const GET_ERROR = "products/"